import React, { Component } from 'react';
import {
  Typography, Grid, FormControl, TextField, List,
  Button, Divider, Hidden, TablePagination, ListItemText,
} from '@material-ui/core';
import MuiListItem from '@material-ui/core/ListItem';
import Skeleton from 'react-loading-skeleton';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import NorLocale from 'date-fns/locale/nb';
import { subYears } from 'date-fns';
import { ListItem } from '@trdk/style/List';
import Select from '../../../components/select';
import ExportDialog from '../committees/export-dialog';

class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: { value: '' },
      fromDate: subYears(new Date(), 1),
      toDate: new Date(),
      currentPage: 0,
      currentRowPerPage: 10,
      searchUser: '',
      openexportDialog: false,
    };
  }

  render() {
    const {
      party,
      classes,
      names,
      namesFetched,
      history: {
        payload: { Resources: historyObject },
        fetching: fetchingHistory,
        fetched: fetchedHistory,
        params: historyParams,
      },
      search,
    } = this.props;
    const {
      selected, fromDate, toDate, currentPage, currentRowPerPage, searchUser, openexportDialog,
    } = this.state;

    const history = historyObject ? historyObject.members : null;

    const min = currentPage * currentRowPerPage;
    const max = min + currentRowPerPage - 1;

    const filtered = history != null ? history
      .filter(item => (`${item.givenName && item.givenName.toLowerCase()} ${item.familyName && item.familyName.toLowerCase()}`)
        .includes(searchUser.toLowerCase()) || searchUser === '') : [];

    const options = [5, 10, 25, 100];
    let paginated = [];
    paginated = filtered.filter((item, i) => i <= max && i >= min);

    return (
      <div className={classes.root}>
        {namesFetched && (
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={NorLocale}>
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                  <Typography variant="h4" color="primary">
                    {party ? 'Historikk parti' : 'Historikk utvalg'}
                  </Typography>
                </Grid>
                {!party && selected.value && [
                  <Grid item xs={12} md={3} key={1}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => this.setState({ openexportDialog: true })}
                    >
                      Eksporter utvalg
                    </Button>
                  </Grid>,
                  <ExportDialog
                    key={2}
                    open={openexportDialog}
                    id={`${selected.value}`}
                    closeDialog={() => this.setState({ openexportDialog: false })}
                    from={`${fromDate.getFullYear()}.${fromDate.getMonth() + 1}.${fromDate.getDate()}`}
                    to={`${toDate.getFullYear()}.${toDate.getMonth() + 1}.${toDate.getDate()}`}
                  />,
                ]}
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    {party ? 'Parti' : 'Utvalg'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl variant="outlined" className={classes.select}>
                    <Select
                      options={names && names.map(v => ({
                        value: v.id,
                        label: party ? `${v.display}` : `${v.display} (${v.code})`,
                      }))}
                      onChange={val => this.setState({ selected: val })}
                      placeholder={party ? 'Parti' : 'Utvalg'}
                    />
                  </FormControl>
                </Grid>
                <Hidden xsDown><Grid item sm={6} /></Hidden>
                <Grid item xs={12} sm={4}>
                  <KeyboardDatePicker
                    className={classes.label}
                    value={fromDate}
                    placeholder="dd.mm.yyyy"
                    onChange={val => this.setState({ fromDate: val })}
                    format="dd.MM.yyyy"
                    inputVariant="outlined"
                    label="Fra og med"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <KeyboardDatePicker
                    className={classes.label}
                    value={toDate}
                    placeholder="dd.mm.yyyy"
                    onChange={val => this.setState({ toDate: val })}
                    format="dd.MM.yyyy"
                    inputVariant="outlined"
                    label="Til"
                  />
                </Grid>
                <Hidden xsDown><Grid item sm={4} /></Hidden>
                <Grid item xs={12}>
                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.button}
                    onClick={() => search(selected.value, fromDate, toDate)}
                    disabled={selected.value === '' || !fromDate || !toDate}
                  >
                    Søk
                  </Button>
                </Grid>
                <Grid item xs={12}><Divider /></Grid>
                {fetchingHistory && (

                  <Grid item xs={12}>
                    <div className={classes.mt}>
                      <List key={2} component="nav" disablePadding>
                        {Object.keys(Array(5).fill(0))
                          .map(val => (
                            <ListItem
                              key={`skel-${val}`}
                              primary={<Skeleton />}
                              secondary={<Skeleton />}
                            />
                          ))
                        }
                      </List>
                    </div>
                  </Grid>
                )}
                {fetchedHistory && !fetchingHistory && [
                  <Grid item xs={12} key="header">
                    <Typography variant="h6" color="primary">
                      {names.map(item => item.id === historyParams.id && (party ? item.display : `${item.display} (${item.code})`))}
                    </Typography>
                    <Typography variant="body1">
                      {`${(historyParams.from).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' })
                      } - ${(historyParams.to).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' })}`}
                    </Typography>
                  </Grid>,
                  (history && history.length > 0) && (
                    <Grid item xs={12} key="search">
                      <TextField className={classes.search} label="Søk etter medlem (navn)" value={searchUser} onChange={e => this.setState({ searchUser: e.target.value, currentPage: 0 })} />
                    </Grid>
                  ),
                  <Grid item xs={12} key="list">
                    {((history && history.length === 0) || (!history)) ? <Typography variant="body1">Ingen medlemmer</Typography> : (
                      <List disablePadding>
                        <Divider />
                        {paginated.length > 0 && paginated.map((item, index) => (
                          <MuiListItem
                            key={item.id}
                            divider
                            className={index % 2 ? classes.odd : ''}
                          >
                            <ListItemText
                              primary={`${item.givenName} ${item.familyName} ${!party && item.represents ? ` (${item.represents})` : ''}`}
                              secondary={`${(item.role && `${item.role}.`) || ''} Fra: ${new Date(item.from).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' })
                              } - til: ${item.to ? new Date(item.to).toLocaleDateString('nb-NO', { month: '2-digit', day: '2-digit', year: 'numeric' }) : 'dagens dato'}`}
                            />
                          </MuiListItem>
                        ))}
                      </List>
                    )}
                  </Grid>,
                ]}
              </Grid>
              {(history && history.length > 0) && [
                <Hidden xsDown key="hiddenxs">
                  <TablePagination
                    component="nav"
                    page={currentPage}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} av ${count}`}
                    labelRowsPerPage="Medlem per side"
                    rowsPerPage={currentRowPerPage}
                    rowsPerPageOptions={options}
                    count={filtered.length}
                    onChangePage={(e, page) => this.setState({ currentPage: page })}
                    onChangeRowsPerPage={e => this.setState({ currentRowPerPage: e.target.value, currentPage: 0 })}
                  />
                </Hidden>,
                <Hidden smUp key="hiddensm">
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body1" className={classes.showingtext}>
                        {`Viser side ${currentPage + 1} av ${Math.ceil(filtered.length / currentRowPerPage)}`}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => this.setState({ currentPage: currentPage - 1 })}
                        disabled={currentPage === 0}
                        fullWidth
                      >
                        Forrige side
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        disabled={(currentPage + 1) >= (filtered.length) / currentRowPerPage}
                        onClick={() => this.setState({ currentPage: currentPage + 1 })}
                      >
                        Neste side
                      </Button>
                    </Grid>
                  </Grid>
                </Hidden>,
              ]}
            </>
          </MuiPickersUtilsProvider>
        )}
      </div>
    );
  }
}

History.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  names: PropTypes.array,
  namesFetched: PropTypes.bool,
  party: PropTypes.bool,
  search: PropTypes.func.isRequired,
};

History.defaultProps = {
  namesFetched: false,
  party: false,
  names: [],
};

const styles = () => ({
  root: {
    maxWidth: '60rem',
    marginBottom: '4rem',
  },
  select: {
    width: '100%',
  },
  button: {
    minWidth: '10rem',
  },
  label: {
    zIndex: 0,
    width: '100%',
  },
  showingtext: {
    color: '#808080',
    marginTop: '1rem',
  },
  search: {
    minWidth: '17rem',
  },
  odd: {
    backgroundColor: '#f7f7f7',
  },
});


export default withStyles(styles)(History);
